import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useOptionalTracker } from '../../../hooks/useTracker';
import InteractionIconButton from './InteractionIconButton';
import unescapedText from 'I18n/utils/unescapedText';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { BREEZE_TOOLTIP_DELAY } from 'chatspot-core/constants/Delays';
import { jsx as _jsx } from "react/jsx-runtime";
const CopyMessageActionButtonTooltip = () => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "aiComponentsUiLibrary.components.inlineFeedback.copyButton.hint"
  });
};
const CopyMessageActionButton = ({
  message,
  usageTracker,
  onCopyMessage
}) => {
  const {
    aiTracker
  } = useOptionalTracker(usageTracker);
  const onCopyButtonClick = useCallback(() => {
    onCopyMessage === null || onCopyMessage === void 0 || onCopyMessage();
    if (aiTracker) {
      aiTracker.track('Ai Components Ui Library', 'Copymessageinteraction', {
        action: 'prompt_copied'
      });
    }
  }, [onCopyMessage, aiTracker]);
  return /*#__PURE__*/_jsx(Tooltip, {
    delay: BREEZE_TOOLTIP_DELAY,
    placement: "right",
    Content: CopyMessageActionButtonTooltip,
    children: /*#__PURE__*/_jsx(InteractionIconButton, {
      dataTestId: "copy-button",
      ariaLabel: unescapedText('aiComponentsUiLibrary.components.inlineFeedback.copyButton.hint'),
      onClick: onCopyButtonClick,
      icon: "copy",
      checked: false,
      valueToCopy: message
    })
  });
};
export default CopyMessageActionButton;